import React, {  } from 'react';
import { useTranslation } from 'react-i18next';

import Page from '../../../components/Page';
import Card from '../../../components/Card';

interface SuccessProps {
    subtitle: string;
}

const Success = (
    {
        subtitle,
    }: SuccessProps
) => {
    const { t } = useTranslation();

    return (
        <Page title={''}>
            <Card
                title={t('marketing.campaign.success')}
                subtitle={subtitle}
                shortHr
            >
            </Card>
        </Page>
    );
};

export default Success;
